import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';
import hu from 'vuetify/lib/locale/hu';

Vuetify.config.silent = process.env.NODE_ENV === 'production';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 640,
      sm: 960,
      md: 1280,
      lg: 1920,
    },
  },
  lang: {
    locales: { hu },
    current: 'hu',
  },
  defaultAssets: {
    font: {
      family: 'Libre Baskerville'
    },
  },
  theme: {
    themes: {
      light: {
        primary: {
          base: '#0C3C60',
          darken1: '#0C3C60',
        },
        secondary: '#ffae01',
        accent: '#364347',
        error: colors.red.accent3,
        muted: colors.grey.lighten4,
        // waring: colors.orange
        uni_blue: "#0C3C60",
        uni_blue2: "#00ADCB",
        archive: "#CFD8DC"
      },
      dark: {
        primary: '#0C3C60',
        secondary: '#00ADCB',
        accent: '#364347',
        white: colors.grey.darken4
      }
    }
  }
});

export default vuetify;
